import React from "react";
import PropTypes from "prop-types";
import { autobind } from "react-decoration";
import qs from "query-string";
import i18next from "i18next";

const ResourceDetailLightBox2 = (Wrapped, Config) => {
  class ResourceDetailLightBox2 extends React.Component {
    constructor(props) {
      super(props);
      let opacity = 0;
      let display = "none";
      if (this.props.isPage) {
        opacity = 1;
        display = "block";
      }
      this.state = {
        changeState: props.changeState,
        opacity: opacity,
        display: display,
      };
    }

    t = (key, param = {}) => {
      return i18next.t(key, param);
    };

    componentWillUnmount() {
      document.body.classList.remove("fix");
    }

    @autobind
    overlay() {
      this.close();
    }

    @autobind
    popup() {
      this.pageYOffset = window.pageYOffset;
      const { t } = this.props;
      if (
        this.refs.wrapped.state.title !== null &&
        this.refs.wrapped.state.title !== undefined &&
        this.refs.wrapped.state.title !== this.state.title
      ) {
        this.setState({ title: t(this.refs.wrapped.state.title) });
      }
      /***Promise**/
      if (
        this.refs.wrapped.beforeOpen !== null &&
        this.refs.wrapped.beforeOpen !== undefined &&
        typeof this.refs.wrapped.beforeOpen === "function"
      )
        this.refs.wrapped.beforeOpen();

      /*let afterOpen =
        this.refs.wrapped.afterOpen !== null  && this.refs.wrapped.afterOpen !== undefined 
          ? this.refs.wrapped.afterOpen()
          : null;*/

      this.setState({ display: "block" });
      setTimeout(
        () =>
          this.setState({ opacity: 1 }, () => {
            this.closeButton.focus();
          }),
        10
      );
    }

    @autobind
    close(type) {
      var isClose = true;

      if (
        this.refs.wrapped.beforeClose !== null &&
        this.refs.wrapped.beforeClose !== undefined &&
        typeof this.refs.wrapped.beforeClose === "function"
      ) {
        isClose = !this.refs.wrapped.beforeClose() ? false : true;
      }

      if (isClose) {
        if (this.state.changeState) {
          let { search, location } = this.props;
          let params = { ...search };
          let url = "";
          if (
            Object.entries(params).length === 0 &&
            params.constructor === Object
          ) {
            url = location.pathname;
          } else {
            url = [location.pathname, qs.stringify(params)].join("?");
          }
          if (type !== undefined && type === "replace")
            window.history.replaceState(params, url, url);
          else window.history.pushState(params, url, url);
        }

        let afterClose =
          this.refs.wrapped.afterClose !== null &&
          this.refs.wrapped.afterClose !== undefined
            ? this.refs.wrapped.afterClose
            : null;
        this.setState({ opacity: 0 });
        setTimeout(() => this.setState({ display: "none" }, afterClose), 1000);

        document.body.classList.remove("fix");
      }
      //$("html, body").animate({ scrollTop: this.pageYOffset }, 0, "easeInSine");
    }

    render() {
      let { t, display } = this;
      return (
        <>
          <div
            className="lightbox archDetails"
            ref="lightbox archDetails"
            style={{
              opacity: this.state.opacity,
              transition: "opacity 1s",
              display: this.state.display,
            }}>
            <div className="overlay" onClick={this.overlay}></div>
            <div className="body">
              <button
                type="button"
                tabIndex="0"
                className="close"
                title={t("jumperrwd.common.close")}
                aria-label={t("jumperrwd.common.close")}
                ref={(c) => {
                  this.closeButton = c;
                }}
                onClick={this.close}></button>
              <Wrapped
                ref="wrapped"
                {...this.props}
                close={this.close}
                display={display}
              />
              <div
                tabIndex="0"
                onFocus={() => {
                  if (this.closeButton) {
                    this.closeButton.focus();
                  }
                }}
              />
            </div>
          </div>
        </>
      );
    }
  }

  ResourceDetailLightBox2.defaultProps = {
    changeState: true,
  };

  ResourceDetailLightBox2.propTypes = {
    changeState: PropTypes.bool,
  };

  return ResourceDetailLightBox2;
};

export default ResourceDetailLightBox2;
